import { autoAffix } from 'utils/wrappers';

import Base from 'app/views/base';
import { SCROLLSPY_FIXED_HEADER_OFFSET } from 'app/views/scrollspy_page';

import tmpl from 'templates/empty';

export default Base.extend({
  compiledTemplate: tmpl,

  events: {
    'change select.predefined-selection': 'swapPredefinedPackagesContent',
    'change .mobile-nav select': 'navigateToHash',
  },

  initialize() {
    const self = this;
    $(window).on('activate.bs.scrollspy', () => {
      const hash = $('.side-nav a.active').attr('href');
      self.displayCurrentSectionOnMobile(hash);
    });

    this.mobileNavHeight = $('.mobile-nav').outerHeight();
    $('body').scrollspy({
      target: '.scrollnav',
      offset: $('.mobile-nav:visible').length ? this.mobileNavHeight : SCROLLSPY_FIXED_HEADER_OFFSET,
    });

    autoAffix();
  },

  swapPredefinedPackagesContent(event) {
    this.$(event.target).find(':selected').tab('show');
  },

  displayCurrentSectionOnMobile(hash) {
    this.$('.mobile-nav select').val(hash);
  },

  navigateToHash(event) {
    const hash = this.$(event.target).find(':selected').val();
    if (window.history) {
      window.history.pushState(null, null, hash);

      // Fixed nav on mobile hides the Heading, so we scroll up after navigation
      $(window).scrollTop($(hash).offset().top - this.mobileNavHeight);
    } else {
      window.location.hash = hash; // old browsers
    }
  },
});



// WEBPACK FOOTER //
// ./app/views/api_docs_page.js